import {Component, ChangeDetectionStrategy} from '@angular/core';
import {SafePipe} from '@app/_helpers/safe.pipe';
import {environment} from "@environments/environment";

@Component({
    selector: 'app-as2-dashboard',
    templateUrl: './aws-dashboard.component.html',
    styleUrl: './aws-dashboard.component.scss',
    imports: [SafePipe],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: true
})
export class AwsDashboardComponent {
    public awsPublicUrl: string = environment.awsDashboardPublicUrl;

    constructor() {
    }
}
